module.exports = __webpack_public_path__ + "img/高通锐化100.995e9dea.png";